import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-body pt-0 pb-5"
}
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", { class: "border-bottom border-gray-200 fs-7 fw-bolder no-padding" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-start" }, " When "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, " Status "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, " Job name "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, " Client "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, " Where "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, " Estimated earning "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end min-w-100px" }, " Info ")
  ])
], -1)
const _hoisted_5 = { class: "fs-7 fw-bold text-gray-700" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-pill bg-warning" }, " Cancelled ", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "badge bg-primary fs-6 text-hover-info" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lg text-white fa-map-marked-alt mx-2" }),
  /*#__PURE__*/_createTextVNode("Map")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_17 = {
  key: 1,
  class: "w-100"
}
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = ["data-bs-target"]
const _hoisted_20 = {
  colspan: "7",
  class: "p-0 m-0"
}
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-6 p-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold" }, "Your wanted contact:", -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "col-6 mt-5 mb-5" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 text-danger" }, "Dresscode: ", -1)
const _hoisted_28 = {
  key: 0,
  class: "fs-6 fw-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SingleActionModal = _resolveComponent("SingleActionModal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PendingShiftsButton = _resolveComponent("PendingShiftsButton")!
  const _component_UserBox = _resolveComponent("UserBox")!
  const _component_PhoneLink = _resolveComponent("PhoneLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SingleActionModal, {
      setup: _ctx.modalSetup,
      onActionButtonClicked: _ctx.handleUnapplyWorker
    }, null, 8, ["setup", "onActionButtonClicked"]),
    (_ctx.shifts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("tbody", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shifts, (entry, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          class: "fw-bold text-dark text-hover-primary",
                          to: '/jobs/' + entry.job_id + '/shifts'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(entry.label.substring(0, 14)) + " ", 1),
                            _hoisted_6,
                            _createTextVNode(" " + _toDisplayString(entry.label.substring(14)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        (entry.status !== 'Cancelled')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_PendingShiftsButton, {
                                status: entry.my_shift_slot.applications[0].status,
                                myShiftSlot: entry.my_shift_slot.applications[0],
                                shiftId: entry.id,
                                index: index,
                                onOpenUnapplyModal: _ctx.handleModalOpen
                              }, null, 8, ["status", "myShiftSlot", "shiftId", "index", "onOpenUnapplyModal"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          class: "fw-bold text-dark text-hover-primary",
                          to: '/jobs/' + entry.job_id + '/shifts'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(entry.job.name), 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(entry.my_shift_slot ? entry.my_shift_slot.skill.name : ""), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          class: "fw-bold text-dark text-hover-primary",
                          to: `/clients/${entry.job.company.id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(entry.job.company.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          class: "text-dark fw-bolder d-block cursor-pointer",
                          onClick: ($event: any) => (_ctx.emitMapModalEvent(entry.job))
                        }, _hoisted_14, 8, _hoisted_12)
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        (_ctx.loadingEstimates)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(entry.my_shift_slot
                      ? _ctx.getEstimatedEarning(entry.my_shift_slot.id)
                      : ""), 1))
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        _createElementVNode("span", {
                          class: "badge bg-primary",
                          type: "button",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": `#collapse_${entry.id}`,
                          "aria-expanded": "false",
                          "aria-controls": "collapseExample"
                        }, " See more ", 8, _hoisted_19)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("div", {
                          id: `collapse_${entry.id}`,
                          class: "collapse in"
                        }, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              (entry.job.project_manager)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createVNode(_component_UserBox, {
                                      class: "pt-5 pb-5",
                                      user: entry.job.project_manager
                                    }, null, 8, ["user"]),
                                    (entry.job.project_manager)
                                      ? (_openBlock(), _createBlock(_component_PhoneLink, {
                                          key: 0,
                                          phone: entry.job.project_manager.phone,
                                          "css-classes": "fs-6 fw-bold text-dark text-hover-primary"
                                        }, null, 8, ["phone"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              (entry.dresscode)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(entry.dresscode.name), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 8, _hoisted_21)
                      ])
                    ])
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}